module.exports = __webpack_public_path__ + "img/storage_cloud.3bcbdb06.png";